export default __webpack_public_path__ + "static/media/PosterVideoHome.00e7715d.jpg";